import { createContext, useContext } from 'react';

import { Equipment, NewCalfEntryInput, Owner } from '@/types.gql';

const CalfEntryContext = createContext<{
  receivedDate: Date | null;
  setReceivedDate: (receivedDate: Date | null) => void;
  owner: Owner | null;
  setOwner: (owner: Owner | null) => void;
  herdsman: Equipment | null;
  setHerdsman: (equipment: Equipment | null) => void;
  calves: NewCalfEntryInput[];
  setCalves: (calves: NewCalfEntryInput[]) => void;
} | null>(null);

export function useCalfEntryContext() {
  const context = useContext(CalfEntryContext);

  if (!context) {
    throw new Error(
      'CalfEntry.* component must be rendered as child of CalfEntry component',
    );
  }

  return context;
}

export default CalfEntryContext;
